import { atom } from "recoil";

export const notificationCountersAtom = atom({
	key: "notificationCounters",
	default: {
		activeCount: 0,
		hiddenCount: 0,
	},
});
